var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"community"},[_c('Header'),_c('div',{attrs:{"name":"bizzabo-web-community","data-unique-name":"237853","data-events-url":"https://events.bizzabo.com"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }